export const triggerAutoloader = (area: HTMLElement) => {
    window.dispatchEvent(
        new CustomEvent('triggerLazyMFLoader', {
            detail: area
        })
    );
};
